import React, { useState, useEffect, useRef } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './LoginPage.css';  // Import your CSS file for styling

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const usernameRef = useRef(null);  // Ref for setting focus to username input

  useEffect(() => {
    // Automatically focus the username field when the component mounts
    usernameRef.current.focus();
  }, []);

  const handleGoogleLoginSuccess = (credentialResponse) => {
    axios.post(`${process.env.REACT_APP_SRV}/auth/google/verify-token`, {
      token: credentialResponse.credential,
    })
    .then(response => {
      const { token } = response.data;

      if (rememberMe) {
        localStorage.setItem('token', token);  // Store JWT token
      } else {
        sessionStorage.setItem('token', token);  // Store JWT token in session storage
      }
      navigate(`/dashboard`);  // Redirect to the selected organization's dashboard
    })
    .catch(error => {
      console.error('Error verifying token:', error);
    });
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();

    axios.post(`${process.env.REACT_APP_SRV}/auth/login`, {
      username,
      password,
    })
    .then(response => {
      const {token} = response.data;

      if (rememberMe) {
        localStorage.setItem('token', token);  // Store JWT token
      } else {
        sessionStorage.setItem('token', token);  // Store JWT token in session storage
      }
      
      navigate(`/dashboard`);  // Redirect to the dashboard
    })
    .catch(error => {
      setErrorMessage('Invalid username or password');
      console.error('Login error:', error);
    });
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gray-900">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg max-w-md w-full text-center">
        <img
          src={`${process.env.REACT_APP_SRV}/uploads/restaurant.webp`}  // Replace with the actual path to your image
          alt="Le Chef Logo"
          className="w-64 h-64 mx-auto mb-4"
        />
        <h1 className="handwritten-logo text-white">Le Chef</h1>
        <img
          src={`${process.env.REACT_APP_SRV}/uploads/5star.png`}  // Replace with the actual path to your image
          alt="Le Chef 5-star"
          className="w-36 h-16 mx-auto mb-4"
        />

        {/* Username/Password Form */}
        <form onSubmit={handleLoginSubmit} className="mb-4">
          <div className="mb-4">
            <input
              type="text"
              value={username}
              ref={usernameRef}  // Focus the username input
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              className="w-full p-2 rounded bg-gray-700 text-white border border-gray-600 focus:outline-none"
              required
            />
          </div>
          <div className="mb-4">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="w-full p-2 rounded bg-gray-700 text-white border border-gray-600 focus:outline-none"
              required
            />
          </div>
          <div className="flex items-center justify-between mb-4">
            <label className="text-white">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="mr-2"
              />
              Remember Me
            </label>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
          >
            Login
          </button>
        </form>

        {/* Error Message */}
        {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}

        <div className="my-4">
          <span className="text-white">or</span>
        </div>

        {/* Google Login */}
        <GoogleLogin
          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}  // Ensure Client ID is passed
          onSuccess={handleGoogleLoginSuccess}
          onError={() => console.error('Google login failed')}
          theme="outline"
          size="large"
        />
      </div>
    </div>
  );
};

export default LoginPage;
